import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { SourceMeta } from './SourceMeta';

const Stat = ({ label, value, testId }) => (
  <div className="p-3 rounded-lg bg-white/5" data-testid={testId}>
    <p className="text-xs text-gray-400">{label}</p>
    <p className="font-mono text-white">{value}</p>
  </div>
);

const pct = (v) => `${v >= 0 ? '+' : ''}${v.toFixed(2)}%`;
const usd = (v) => (v == null ? 'N/A' : `$${v.toFixed(2)}`);

export const TrendCard = ({ prices, trend }) => {
  if (!prices?.available) {
    return <p className="text-sm text-gray-400" data-testid="research-prices-unavailable">Price data unavailable: {prices?.reason}</p>;
  }
  const bars = prices.bars.slice(-60);
  return (
    <div data-testid="research-trend-card">
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={bars}>
            <XAxis dataKey="date" tick={{ fill: '#6b7280', fontSize: 10 }} minTickGap={30} />
            <YAxis domain={['auto', 'auto']} tick={{ fill: '#6b7280', fontSize: 10 }} width={50} />
            <Tooltip contentStyle={{ background: '#1A1A1A', border: '1px solid #333' }} />
            <Line type="monotone" dataKey="close" stroke="#00E676" dot={false} strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      {trend?.available ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3">
          <Stat label={`Last close (${trend.lastSession})`} value={usd(trend.lastClose)} testId="trend-last-close" />
          <Stat label="5-session change" value={pct(trend.change5SessionsPct)} testId="trend-change-5" />
          <Stat label="20-session change" value={pct(trend.change20SessionsPct)} testId="trend-change-20" />
          <Stat label="20-session SMA" value={`${usd(trend.sma20)} (${trend.relationToSma20})`} testId="trend-sma20" />
          <Stat label="50-session SMA" value={usd(trend.sma50)} testId="trend-sma50" />
          <Stat label="Hist. volatility (ann.)" value={`${trend.annualizedHistoricalVolatilityPct.toFixed(2)}%`} testId="trend-volatility" />
        </div>
      ) : (
        <p className="text-sm text-gray-400 mt-3" data-testid="research-trend-unavailable">Indicators unavailable: {trend?.reason}</p>
      )}
      {trend?.volatilityMethod && <p className="text-xs text-gray-500 mt-2">{trend.volatilityMethod}</p>}
      <SourceMeta source={prices.source} testId="research-price-source" />
    </div>
  );
};
